var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviousexports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_351_898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0667 14.6663H12.4C12.7536 14.6663 13.0927 14.5259 13.3428 14.2758C13.5928 14.0258 13.7333 13.6866 13.7333 13.333V4.66634L10.4 1.33301H4.39998C4.04636 1.33301 3.70722 1.47348 3.45717 1.72353C3.20713 1.97358 3.06665 2.31272 3.06665 2.66634V4.66634",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7334 1.33301V3.99967C9.7334 4.3533 9.87387 4.69244 10.1239 4.94248C10.374 5.19253 10.7131 5.33301 11.0667 5.33301H13.7334",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7334 14.667C7.94254 14.667 9.7334 12.8761 9.7334 10.667C9.7334 8.45785 7.94254 6.66699 5.7334 6.66699C3.52426 6.66699 1.7334 8.45785 1.7334 10.667C1.7334 12.8761 3.52426 14.667 5.7334 14.667Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7334 11.6663L5.7334 10.833V9.33301",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.400024)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousexports);
export default __webpack_public_path__ + "static/media/previousexports.75c36fc582e64a92316510f27c2cfc41.svg";
export { ForwardRef as ReactComponent };